import styled from "styled-components"

const WrapBussinessReject = styled.div`
    height: calc(100% - 82px);

`

export {
    WrapBussinessReject
}